import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ActionModal } from "@components";
import { ValidationChallengePayload } from "@interfaces";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string | React.ReactNode;
  createValidationChallenge: (payload: ValidationChallengePayload) => void;
}

export const ActionRetryModal: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  description,
  createValidationChallenge,
}) => {
  const navigate = useNavigate();

  const handleVolverAlInicio = useCallback(() => {
    onClose();
    navigate("/app/solicitudes");
  }, [onClose, navigate]);

  const handleRetry = useCallback(async () => {
    await createValidationChallenge({});
    onClose();
  }, [createValidationChallenge, onClose]);

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={handleRetry}
      title={title}
      description={description}
      secondaryButton={{
        label: "Volver al inicio",
        onClick: handleVolverAlInicio,
      }}
      primaryButton={{
        label: "Reintentar",
        onClick: handleRetry,
      }}
    />
  );
};
